export default function displayDurationFilter(Utils) {
  'ngInject';

  return function displayDuration(durationInMinutes, short = false) {
    const decimalFormat = Utils.getDecimalFormat();
    return (
      Utils.getDisplayDuration(durationInMinutes, decimalFormat, short) || `0${short ? 'H' : 'h'}`
    );
  };
}
